import { ArrowRight } from "lucide-react"

export const PhaseStepper = ({ phases, currentId, onChange }: {
  phases: API.PROJECTHQ_NEW.Stage[]
  currentId?: number
  onChange: (stage: API.PROJECTHQ_NEW.Stage) => void
}) => <div className="flex items-center gap-3 overflow-x-auto py-4">
  {phases.map((phase, index) => <div key={phase.id} className="flex items-center gap-3 shrink-0">
    {index > 0 && <ArrowRight size={16} className="text-gray-400" />}
    <button aria-pressed={phase.id === currentId} onClick={() => onChange(phase)}
      className={`px-4 py-3 rounded-lg flex items-center gap-2 ${phase.id === currentId ? "bg-blue-100 text-blue-700 font-semibold" : "text-gray-600 hover:bg-gray-100"}`}>
      {phase.name}
      {phase.uncompletedCount > 0 && <span className={`text-xs rounded-full border border-red-500 px-2 ${phase.id === currentId ? "bg-red-500 text-white" : "text-red-500"}`}>{phase.uncompletedCount}</span>}
    </button>
  </div>)}
</div>
